<!--
 * @Date: 2022-08-04 16:29:35
 * @LastEditors: StavinLi
 * @LastEditTime: 2022-09-21 14:14:32
 * @FilePath: /Workflow/src/components/drawer/copyerDrawer.vue
-->
<template>
  <Drawer
    :transfer="true"
    title="抄送人设置"
    v-model="visible"
    placement="right"
    class="set_copyer"
    :closable="false"
    width="550px"
    :before-close="closeDrawer"
  >
    <div class="demo-drawer__content">
      <div>
        <!-- 当为人工审批时，展示下面的东西，复杂逻辑 -->
        <!-- 首先是一个tabs -->
        <dealwithInfo
          ref="dealwithInfoRef"
          v-if="visible"
          :dataConfig.sync="copyerConfig"
          typeTitle="抄送人"
        />
      </div>
    </div>
    <div class="demo-drawer__footer clear">
      <Button @click="closeDrawer">取 消</Button>
      <Button type="primary" @click="saveCopyer">确 定</Button>
    </div>
  </Drawer>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { dealwithInfo } from '../drawerInfo';
import preload from '../../plugins/preload';
import { userTypeConfig } from './drawerConfig';
export default {
  components: {
    dealwithInfo
  },
  data() {
    return {
      copyerConfig: {},
      ccSelfSelectFlag: [],
      copyerVisible: false,
      checkedList: [],
      visible: false
    };
  },
  computed: {
    ...mapState('workflow', ['copyerDrawer', 'copyerConfig1'])
  },
  watch: {
    copyerDrawer(val) {
      this.visible = val;
    },
    copyerConfig1(val) {
      this.copyerConfig = val.value;
      this.ccSelfSelectFlag =
        this.copyerConfig.ccSelfSelectFlag == 0
          ? []
          : [this.copyerConfig.ccSelfSelectFlag];
    }
  },
  methods: {
    ...mapMutations('workflow', ['setCopyerConfig', 'setCopyer']),
    addCopyer() {
      this.copyerVisible = true;
      this.checkedList = this.copyerConfig.nodeUserList;
    },
    sureCopyer(data) {
      this.copyerConfig.nodeUserList = data;
      this.copyerVisible = false;
    },
    saveCopyer() {
      const { userType } = this.copyerConfig;
      // 如果是指定人员｜指定部门｜指定角色时 保存对应选择的人员
      if (![4, 5].includes(userType)) {
        const { listName } = userTypeConfig[userType];
        const dealwithInfoDom = this.$refs.dealwithInfoRef;
        const { list } = dealwithInfoDom;
        const nodeUserList = list[listName];
        this.copyerConfig.nodeUserList = nodeUserList;
        this.copyerConfig.nodeExecUsers = nodeUserList.map(i => {
          // 当是部门的时候，后端要 relationId
          return userType == 2 ? i.relationId : i.id;
        });
      }
      this.copyerConfig.ccSelfSelectFlag =
        this.ccSelfSelectFlag.length == 0 ? 0 : 1;
      this.copyerConfig.error = !preload.copyerStr(this.copyerConfig);
      console.log('this.coperConfig.error', this.copyerConfig.error);
      this.setCopyerConfig({
        value: this.copyerConfig,
        flag: true,
        id: this.copyerConfig1.id
      });
      this.closeDrawer();
    },
    closeDrawer() {
      this.setCopyer(false);
    }
  }
};
</script>

<style lang="less">
.set_copyer {
  .copyer_content {
    padding: 20px 20px 0;

    .Button {
      margin-bottom: 20px;
    }

    .Checkbox {
      margin-bottom: 20px;
    }
  }
}
</style>
